import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { storeName as layoutModelStore } from '../models/layout.model';
import { PromotionResponseTypes } from '../../types/response/promotion';
import { getPromotionsByKey } from '../../services/projectChildItem.service';

export const storeName = 'promotionEntity';

export const promotionEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: PromotionResponseTypes[]) => {
      (entities || []).forEach((entity) => {
        state.ids[entity.code] = entity;
      });
    }),
  },

  effects: (dispatch: RematchDispatch<typeof promotionEntity>) => ({
    async loadByKey(payload: string, state: RootModel) {
      const { locale } = state[layoutModelStore];

      const resp = await getPromotionsByKey(payload, locale.apiLanguage);
      this.saves(resp);
      return resp;
    },
  }),
});

export default promotionEntity;
